(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["plural-cart-button"] && !Shopify.designMode) return;
  try {
    const buttons = document.querySelectorAll(".save-product-button");
    buttons.forEach((button) => button.addEventListener("click", saveProduct));

    function saveProduct(e) {
        // Get the data set on the target button
        const data = e.target.dataset;

        // Set the productCallback function
        window.cartSaver.productCallback = function () {
            return [
                {
                    variant_id: data.variantId,
                    quantity: 1,
                    properties: null,
                },
            ];
        };

        // Open the modal
        window.cartSaver.openSelector();
    }
  } catch(e) { console.error(e); }
})();

})();
